// @flow
import type { TagDeviceType } from '~/core/constants/actions';
import type { SavingState } from '~/core/state/actions/types';
import type { Filter, TemplateComponent } from '../types';

import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { isEqual, noop } from 'lodash/fp';
import { StandardLayout, Tabs } from '~/components/widgets';
import QuerystringTabManager from '~/components/widgets/querystring-tab-manager';
import generalIcons from '~/core/constants/icons/general-svg';
import { TAB_KEY, TAB_ACTIONS, TAB_DISCOVER } from './constants';
import TabSwitch from '~/components/widgets/tabs-content';
import { filtersType } from '../constants';
import DiscoverActions from './discover-actions';
import MyActions from './my-actions';
import ActionCanvas from './action-canvas';
import messages from './intl';
import { Redirect } from 'react-router-dom';
import { dashboard } from '~/core/constants/routes';

type Props = {
    currentQueryStringTab: ?string,
    getActions: noop,
    getTemplates: noop,
    loadActionIdForm: noop,
    productId?: string,
    savingState: SavingState,
    showFilter?: boolean,
    tagDeviceType?: TagDeviceType
};
type State = {
    currentFilter: Filter,
    redirectToDashboard: boolean,
    redirectToMyActions: boolean,
    removeAction: ?{ id: string, name: string, deprecated?: boolean },
    selectedTemplate: ?TemplateComponent
};
export default class ActionEntry extends Component<Props, State> {
    state = {
        currentFilter: { name: filtersType.SHOW_ALL },
        redirectToDashboard: false,
        redirectToMyActions: false,
        removeAction: null,
        selectedTemplate: undefined
    };

    constructor(props: Props) {
        super(props);
        const { tagDeviceType } = props;

        if (tagDeviceType) {
            this.state = {
                ...this.state,
                currentFilter: { name: filtersType.BY_DEVICE, selectedItem: tagDeviceType }
            };
        }
    }

    componentDidMount() {
        const { getActions, getTemplates, loadActionIdForm } = this.props;

        getActions();
        getTemplates();
        loadActionIdForm();
    }

    componentWillReceiveProps(nextProps: Props) {
        if (this.props.savingState === 'saving' && nextProps.savingState === 'done') {
            if (this.props.tagDeviceType === 'quick-action') {
                this.setState({ redirectToDashboard: true, selectedTemplate: undefined });
                return;
            }

            if (this.props.currentQueryStringTab === TAB_DISCOVER) {
                this.setState({ redirectToMyActions: true, selectedTemplate: undefined });
                return;
            }
        }

        if (this.props.savingState === 'done' && nextProps.currentQueryStringTab === TAB_DISCOVER) {
            this.setState({ redirectToMyActions: false });
        }
    }

    changeFilter = (newFilter: Filter) => {
        if (!isEqual(this.state.currentFilter, newFilter)) {
            this.setState({ currentFilter: newFilter });
        }
        this.selectTemplate();
    };

    selectTemplate = (template: ?TemplateComponent) => this.setState({ selectedTemplate: template });

    showConfirmModal = (actionId: string, name: string, deprecated: boolean = false) =>
        this.setState({ removeAction: { id: actionId, name, deprecated } });

    hideConfirmModal = () => this.setState({ removeAction: null });

    render() {
        const { productId, showFilter } = this.props;
        const { currentFilter, redirectToDashboard, redirectToMyActions, removeAction, selectedTemplate } = this.state;

        return [
            <QuerystringTabManager key="actions-tabs" tabGroup={TAB_KEY}>
                <Tabs maxWidth>
                    {/* $FlowFixMe */}
                    <Tabs.Item icon={generalIcons.ACTIONS} name={TAB_ACTIONS}>
                        <FormattedMessage {...messages.myActions} />
                    </Tabs.Item>
                    <Tabs.Item icon={generalIcons.DISCOVER} name={TAB_DISCOVER}>
                        <FormattedMessage {...messages.discoverActions} />
                    </Tabs.Item>
                </Tabs>
            </QuerystringTabManager>,
            <StandardLayout key="actions-constant">
                <TabSwitch tabGroup={TAB_KEY}>
                    <TabSwitch.Screen
                        component={MyActions}
                        name={TAB_ACTIONS}
                        productId={productId}
                        removeAction={this.showConfirmModal}
                    />
                    <TabSwitch.Screen
                        changeFilter={this.changeFilter}
                        component={DiscoverActions}
                        currentFilter={currentFilter}
                        name={TAB_DISCOVER}
                        selectedTemplate={selectedTemplate}
                        selectTemplate={this.selectTemplate}
                        showFilter={showFilter}
                    />
                </TabSwitch>
            </StandardLayout>,
            <ActionCanvas
                key="action-canvas"
                parentRemoveActionState={removeAction}
                parentResetActionState={this.hideConfirmModal}
            />,
            <span key="redirect">
                {redirectToDashboard && <Redirect to={dashboard} />}
                {redirectToMyActions && <Redirect to={{ search: `?${TAB_KEY}=${TAB_ACTIONS}` }} />}
            </span>
        ];
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/component.js